import uniqueId from 'lodash/uniqueId';
import isArray from 'lodash/isArray';
import times from 'lodash/times';
import elementFactory from '../elements/factory';
import columnFactory from '../elements/column';
import actionFactory from '../props/action';
import paddingModifier from '../props/padding-modifier';
import { ELEMENT } from '../const';
import { sumWeight } from '../../util';

/**
 * Парсер блока div-table-block
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-table-block.json
 * @param  {Object} block
 * @return {Object}
 */
export default (function (block) {
    var rows = (block.rows || []).map(elementFactory).filter(Boolean);

    if (!rows.length) {
        return null;
    }

    var columns = fillColumns(getColumns(block.columns), rows);

    return {
        rows: rows,
        columns: columns,
        action: actionFactory(block),
        paddingModifier: paddingModifier(block),
        type: block.type,
        id: uniqueId('block_'),
        weight: sumWeight(rows)
    };
});

var getColumns = function getColumns(columns) {
    if (isArray(columns)) {
        return columns.map(columnFactory).filter(Boolean);
    }

    return [];
};

var fillColumns = function fillColumns(columns, rows) {
    var columnsNeeded = rows.reduce(function (aux, row) {
        if (row.type !== ELEMENT.row) {
            return aux;
        }

        return Math.max(row.cells.length, aux);
    }, 0);

    if (columns.length === columnsNeeded) {
        return columns;
    }

    var count = columnsNeeded - columns.length;

    return columns.concat(times(count, columnFactory));
};